<template>
  <v-app>
    <v-main>
      <Alert />
      <router-view
        v-slot="{ Component }"
        :key="$route.fullPath"
      >
        <component :is="Component" />
      </router-view>
    </v-main>
  </v-app>
</template>

<script lang="ts" setup>
import Alert from './components/Alert.vue'
</script>
